import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "footer" }
const _hoisted_4 = ["data-closetext", "data-opentext"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "drop-content" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "js-calcChildHeight" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "people-count" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EasyDrop = _resolveComponent("EasyDrop")!
  const _component_DotSpinner = _resolveComponent("DotSpinner")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.currentViewName === 'hotel')
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: "back-btn",
          href: _ctx.pageUrls.pageHotelList
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: "overviewOpen",
      class: _normalizeClass({ active: _ctx.tabletActive }),
      hidden: ""
    }, [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tabletActive = !_ctx.tabletActive))
      }, [
        (!_ctx.tabletActive)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewHeadline']), 1))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("aside", {
      id: "bookingOverview",
      class: _normalizeClass(["easy-drop full-mobile", { active: _ctx.isActive }])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["drop-open", { active: _ctx.isActive }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isActive = !_ctx.isActive)),
          "data-closetext": _ctx.pageTexts['hotelPageTravelOverviewButtonClose'],
          "data-opentext": _ctx.pageTexts['hotelPageTravelOverviewButtonOpen']
        }, null, 10, _hoisted_4),
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelPriceTotal']) + " ", 1),
              (_ctx.pageTexts['hotelPageTravelOverviewInfoPopup'])
                ? (_openBlock(), _createBlock(_component_EasyDrop, {
                    key: 0,
                    dropdownType: 'tooltip',
                    position: 'center',
                    hasTopTip: true
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "rte",
                        innerHTML: _ctx.pageTexts['hotelPageTravelOverviewInfoPopup']
                      }, null, 8, _hoisted_5)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            (_ctx.bookingOverview.price.price)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.bookingOverview.price.price.toLocaleString(_ctx.localeStrings.longName)) + " " + _toDisplayString(_ctx.bookingOverview.price.currency), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  _createVNode(_component_DotSpinner)
                ]))
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelPricePerPerson']), 1),
            (_ctx.bookingOverview.price.pricePerPerson)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.bookingOverview.price.pricePerPerson.toLocaleString(_ctx.localeStrings.longName)) + " " + _toDisplayString(_ctx.bookingOverview.price.currency), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                  _createVNode(_component_DotSpinner)
                ]))
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["drop-open", { active: _ctx.isActive }])
      }, null, 2),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("nav", null, [
          _createElementVNode("header", null, [
            (_ctx.currentViewName === 'hotel')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "back-btn",
                  href: _ctx.pageUrls.pageHotelList,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isActive = false))
                }, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelBackToHotelList']), 9, _hoisted_11))
              : _createCommentVNode("", true),
            (_ctx.currentViewName === 'accommodation')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: { name: 'hotel', query: _ctx.searchQuery },
                  class: "back-btn",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isActive = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelBackToHotel']), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (_ctx.currentViewName === 'pension')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  to: { name: 'accommodation', query: _ctx.searchQuery },
                  class: "back-btn",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isActive = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelBackToRooms']), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (_ctx.currentViewName === 'departure')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 3,
                  to: { name: 'pension', query: _ctx.searchQuery },
                  class: "back-btn",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isActive = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelBackToPensions']), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (_ctx.currentViewName === 'transfer')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 4,
                  to: { name: 'departure', query: _ctx.searchQuery },
                  class: "back-btn",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isActive = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelBackToDepartures']), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            ((_ctx.currentViewName === 'personal-data' || _ctx.currentViewName === 'personal-data-overview') && _ctx.bookingOverview.transfers.length)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 5,
                  to: { name: 'transfer', query: _ctx.searchQuery },
                  class: "back-btn",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isActive = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelBackToTransfer']), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            ((_ctx.currentViewName === 'personal-data' || _ctx.currentViewName === 'personal-data-overview') && !_ctx.bookingOverview.transfers.length)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 6,
                  to: { name: 'departure', query: _ctx.searchQuery },
                  class: "back-btn",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isActive = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelBackToDepartures']), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (_ctx.currentViewName === 'travel-overview')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 7,
                  to: { name: 'personal-data', query: _ctx.searchQuery },
                  class: "back-btn",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isActive = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelBackToPersonalInfo']), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            _createElementVNode("h2", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewHeadline']), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", null, [
              _createElementVNode("a", null, [
                _createElementVNode("span", null, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelYourTravel']), 1),
                  (_ctx.bookingOverview.travel.toDestinationDate && _ctx.bookingOverview.travel.fromDestinationDate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.formatDate(_ctx.bookingOverview.travel.toDestinationDate)) + " " + _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelYourTravelTo']) + " " + _toDisplayString(_ctx.formatDate(_ctx.bookingOverview.travel.fromDestinationDate )), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_14, [
                    _createTextVNode(_toDisplayString(_ctx.adultsCount) + " " + _toDisplayString(_ctx.adultSinglePlural(_ctx.adultsCount)) + " ", 1),
                    (_ctx.childrenCount > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" , " + _toDisplayString(_ctx.childrenCount) + " " + _toDisplayString(_ctx.childSinglePlural(_ctx.childrenCount)), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.bookingOverview.flight.toDestinationSummary.startDepartureAirportName) + " (" + _toDisplayString(_ctx.bookingOverview.flight.toDestinationSummary.startDepartureAirportCode) + ")", 1)
                ])
              ]),
              _createVNode(_component_router_link, {
                to: { name: 'hotel', query: _ctx.searchQuery },
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isActive = false))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.hotelLabel), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.bookingOverview.travel.hotelName), 1)
                  ])
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(_component_router_link, {
                to: { name: 'accommodation', query: _ctx.searchQuery },
                onClick: _ctx.navigateAccomodationIndex
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, [
                    (_ctx.compSelectedRooms.length <= 1)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.compSelectedRooms.length <= 1)
                            ? (_openBlock(), _createElementBlock("strong", _hoisted_15, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelRoom']), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, _toDisplayString(_ctx.compSelectedRooms[0].name), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelRooms']), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.compSelectedRooms, (room, index) => {
                            return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelRoom']) + " " + _toDisplayString(index + 1) + ": " + _toDisplayString(room.name), 1))
                          }), 128))
                        ], 64))
                  ])
                ]),
                _: 1
              }, 8, ["to", "onClick"]),
              _createVNode(_component_router_link, {
                to: { name: 'pension', query: _ctx.searchQuery },
                onClick: _ctx.navigatePensionIndex
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelCatering']), 1),
                    (_ctx.selectedPensions.length <= 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.selectedPensions[0].name), 1))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.selectedPensions, (pension, index) => {
                          return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelRoom']) + " " + _toDisplayString(index + 1) + ": " + _toDisplayString(pension.name), 1))
                        }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["to", "onClick"]),
              _createVNode(_component_router_link, {
                to: { name: 'departure', query: _ctx.searchQuery },
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isActive = false))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelFlight']), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelFlightDeparture']) + " " + _toDisplayString(_ctx.formatDateTime(
                                            _ctx.bookingOverview.flight.toDestinationSummary.startDepartureDate
                                                                        )), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelFlightArrival']) + " " + _toDisplayString(_ctx.formatDateTime(
                                            _ctx.bookingOverview.flight.fromDestinationSummary.endArrivalDate
                                                                        )), 1)
                  ])
                ]),
                _: 1
              }, 8, ["to"]),
              (_ctx.bookingOverview.transfers.length)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: { name: 'transfer', query: _ctx.searchQuery },
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isActive = false))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelTransfer']), 1),
                        (_ctx.selectedTransfer)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.selectedTransfer.name), 1))
                          : (_openBlock(), _createElementBlock("em", {
                              key: 1,
                              innerHTML: _ctx.obligatoryTransferText()
                            }, null, 8, _hoisted_18))
                      ])
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true),
              _createVNode(_component_router_link, {
                to: { name: 'personal-data', query: _ctx.searchQuery },
                class: _normalizeClass({ 'router-link-active': _ctx.currentViewName === 'personal-data-overview', disabled: !_ctx.isPersonalDataAvailable }),
                onClick: _ctx.navigatePersonalIndex
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelPersonalInformation']), 1)
                  ])
                ]),
                _: 1
              }, 8, ["to", "class", "onClick"]),
              _createVNode(_component_router_link, {
                to: { name: 'travel-overview', query: _ctx.searchQuery },
                class: _normalizeClass({ disabled: !_ctx.isConfirmAndPayAvailable })
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelConfirmAndPay']), 1)
                  ])
                ]),
                _: 1
              }, 8, ["to", "class"])
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}